import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppRoutingModule } from 'app/app-routing.module';
import { AppComponent } from 'app/app.component';
import { DarwinModule } from 'app/modules/darwin/darwin.module';
import { MainModule } from 'app/modules/main/main.module';
import { AnalyticsEventSender } from 'app/modules/main/services/analytics-event-sender.service';
import { AUTH_PROVIDER_SCOPE_PREFIX } from 'app/modules/main/services/user-authorizer.service';
import { AUTH_USER_SCOPE_PREFIX } from 'app/modules/main/services/user-authorizer.service';
import { GATEKEEPER_FEATURES } from 'app/modules/main/services/user-feature-flags-fetcher.service';
import { WindowWrapperService } from '@awin/shared';
import { BaseConfigService } from '@awin/shared';
import { GoogleAnalyticsModule, GoogleAnalyticsService } from '@awin/shared/google-analytics';
import { googleAnalytics } from 'environments/environment';
import { environment } from 'environments/environment';
import { appName } from 'environments/environment';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { CustomAuthStorageService } from './services/custom-auth-storage/custom-auth-storage.service';
import { NetworkGroupService } from '@awin/navigation-renderer';
import { configureOAuth } from './oauth-config/oauth-config';
import { OAuthModule, OAuthStorage, OAuthService } from 'angular-oauth2-oidc';
import {
  customUrlValidation,
} from './oauth-config/oauth-config';

@NgModule({ bootstrap: [AppComponent],
    declarations: [AppComponent], imports: [AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        DarwinModule,
        EffectsModule.forRoot([]),
        GoogleAnalyticsModule.forRoot({ trackId: googleAnalytics.trackingId }),
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [],
                customUrlValidation,
                sendAccessToken: true,
            },
        }),
        MainModule,
        StoreModule.forRoot({}, {
            runtimeChecks: {
                strictStateImmutability: !(environment.staging || environment.production),
                strictActionImmutability: !(environment.staging || environment.production),
                strictStateSerializability: !(environment.staging || environment.production),
                strictActionSerializability: !(environment.staging || environment.production),
                strictActionWithinNgZone: !(environment.staging || environment.production),
                strictActionTypeUniqueness: !(environment.staging || environment.production),
            },
        }),
        (environment.staging || environment.production)
            ? []
            : StoreDevtoolsModule.instrument({
                name: appName,
                maxAge: 100,
                logOnly: false,
            })], providers: [
        OAuthService,
        { provide: OAuthStorage, useClass: CustomAuthStorageService },
        {
            provide: APP_INITIALIZER,
            useFactory: (networkGroupService: NetworkGroupService) => (): void => {
                if (!window.location.pathname.includes('/oidc')) {
                    networkGroupService.initialiseNetworkGroup();
                }
            },
            multi: true,
            deps: [NetworkGroupService],
        },
        {
            deps: [
                WindowWrapperService
            ],
            provide: BaseConfigService,
            useFactory: (windowWrapperService: WindowWrapperService) => {
                return new BaseConfigService(windowWrapperService, {
                    production: environment.production,
                    name: googleAnalytics.enabled ? 'prod' : '',
                });
            },
        },
        {
            deps: [
                BaseConfigService,
                GoogleAnalyticsService,
            ],
            provide: AnalyticsEventSender,
            useFactory: (configService, googleAnalyticsService) => {
                return new AnalyticsEventSender(configService, googleAnalyticsService, googleAnalytics.debugEvents);
            },
        },
        {
            provide: AUTH_PROVIDER_SCOPE_PREFIX,
            useValue: 'provider:accounts:cc:',
        },
        {
            provide: AUTH_USER_SCOPE_PREFIX,
            useValue: 'user:accounts:cc:',
        },
        {
            provide: GATEKEEPER_FEATURES,
            useValue: [
                'communication-centre-enabled',
                'communication-centre-automations-enabled',
                'communication-centre-performance-updates'
            ],
        },
        {
            provide: APP_BASE_HREF,
            useFactory: () => `/${window.location.pathname.split('/').splice(1, 3).join('/')}/`,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: configureOAuth,
            multi: true,
            deps: [HttpClient],
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
